import type { LanguageCode } from "~/consts/languages"

export interface SettingsStore {
  language: LanguageCode
}
export const settingsStore: SettingsStore = {
  language: "nb",
}
